const STORAGE_KEY = 'klfb_session'

export type StoredSession = {
  token: string
  expiresAt: string
  actorLabel?: string | null
}

export function readHashToken(): string | null {
  const hash = location.hash.startsWith('#') ? location.hash.slice(1) : location.hash
  const params = new URLSearchParams(hash)
  const fromParams = params.get('klfb')
  if (fromParams) return fromParams
  const m = location.hash.match(/(?:^[#&]?)klfb=([^&]+)/)
  return m ? decodeURIComponent(m[1]) : null
}

export function stripHashToken(): void {
  const url = new URL(location.href)
  if (!url.hash.includes('klfb=')) return
  const hash = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash
  const parts = hash.split('&').filter((p) => p && !p.startsWith('klfb='))
  url.hash = parts.length ? parts.join('&') : ''
  history.replaceState(null, '', url.pathname + url.search + (url.hash ? url.hash : ''))
}

export function loadStoredSession(): StoredSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredSession
    if (!parsed?.token || !parsed?.expiresAt) return null
    if (new Date(parsed.expiresAt).getTime() < Date.now()) {
      clearSession()
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function storeSession(session: StoredSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export function clearSession(): void {
  sessionStorage.removeItem(STORAGE_KEY)
}

export function resolveApiBase(scriptEl: HTMLScriptElement | null): string {
  const fromData = scriptEl?.getAttribute('data-api')?.trim()
  if (fromData) return fromData.replace(/\/$/, '')
  return 'https://app.kiwiloop.ai'
}
